export default "__VITE_ASSET__Do7oWz____"